import { ICardMotorsportsCalendar } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidDataCardCalendar } from './typeguards';
import { CardGpCalendarGpInfo, CreateCardGpCalendarWidgetInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { intcmpMap } from '../../../utils/intcmp';
import { DataCardCalendarQuery } from '../types';

export default (obj: DataCardCalendarQuery): ICardMotorsportsCalendar=> {
  if (isValidDataCardCalendar(obj)) {
    CreateCardGpCalendarWidgetInputSchema().parse(obj.data.getCardGpCalendarWidget, {reportInput: true});
    const { gpList, calendarLink, customCompetitionName, competitionId } = obj.data.getCardGpCalendarWidget;

    return {
      calendarLink,
      customCompetitionName,
      competitionId,
      gpList: gpList?.map((gpObj) => {
        const gp = gpObj as CardGpCalendarGpInfo;
        const { lgpPreviewUrl, customGpName, flagUrl, startDateTime, endDateTime, isExclusive } = gp;

        return {
          customGpName,
          flagUrl,
          startDateTime,
          endDateTime,
          isExclusive,
          targetUrl: lgpPreviewUrl,
          trackingData: { intcmp: intcmpMap.dataCardCalendar.detailLink },
        };
      }),
      trackingData: { 'analytics-element': 'card-calendar-motorsport-formula1' },
      cardCtaTrackingData: {
        intcmp: intcmpMap.dataCardCalendar.viewAllCta,
      },
    } as ICardMotorsportsCalendar;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in DataCardCalendarQuery object',
      data: obj
    });
  }
};
